<template>
  <div>
    <div class="grid gap-4 py-6 border-t bg-gray-50 md:grid-cols-3 auto-rows-auto lg:grid-cols-5">
      <DatePicker class="col-span-2" color="indigo" mode="dateTime" :minute-increment="5" is-range is24hr v-model="filter.date" :model-config="{ start: { timeAdjust: '00:00:00' }, end: { timeAdjust: '23:59:59' } }">
        <template v-slot="{ inputValue, inputEvents }">
          <div class="flex justify-center">
            <input
              :value="inputValue.start"
              v-on="inputEvents.start"
              class="w-40 form-input prepend"
            />
            <div class="flex items-center justify-center flex-none w-10 border bg-gray-50">
              &rarr;
            </div>
            <input
              :value="inputValue.end"
              v-on="inputEvents.end"
              class="w-40 form-input append"
            />
          </div>
        </template>
      </DatePicker>
      <AreaSelect v-model="filter.area" />
      <VehicleSelect v-model="filter.vehicle" />
    </div>

    <div>
      <div v-if="report">
        <!-- No Results -->
        <div v-if="report.rows.length === 0" class="p-8 m-6 text-center text-gray-500 rounded-b-lg bg-gray-50">
          No results. Try broadening your query parameters.
        </div>
        <!-- Results -->
        <div class="card" v-else>
          <div class="flex flex-col justify-between p-4 border-b md:flex-row lg:p-5">
            <button class="ml-auto btn btn-sm btn-outline" @click="$parent.downloadReport()" v-submitting="$parent.submitting">
              <fa :icon="['far', 'arrow-to-bottom']" class="mr-2" /> Download
            </button>
          </div>
          <data-table
            small
            :items="report.rows" 
            :keys="[
              { name: 'Entered', slug: 'entered_at', display: (val) => { return format(new Date(val), 'HH:mm dd/MM/yyyy') } },
              { name: 'Exited', slug: 'exited_at', display: (val) => { return format(new Date(val), 'HH:mm dd/MM/yyyy') } },
              { name: 'Duration', slug: 'duration' },
              { name: 'Distance', slug: 'distance' },
              { name: 'Vehicle Name', slug: 'vehicle_name' },
              { name: 'Vehicle No', slug: 'vehicle_number' },
              { name: 'Driver Name', slug: 'driver_name' },
              { name: 'Driver No', slug: 'driver_number' },
            ]" />
          <Pagination :total="report.meta.total" :per-page="report.meta.per_page" :current-page="report.meta.current_page" />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { sub, format } from 'date-fns'
import DatePicker from 'v-calendar/lib/components/date-picker.umd'
import AreaSelect from '@/components/AreaSelect.vue'
import VehicleSelect from '@/components/VehicleSelect.vue'

export default {
  name: 'AreaVisitReport',

  components: {
    DatePicker,
    AreaSelect,
    VehicleSelect
  },

  props: {
    report: {
      type: Object
    }
  },

  computed: {
    params () {
      return { 
        filter: this.filter,
      }
    }
  },

  data () {
    return {
      filter: {
        date: {
          start: sub(new Date(), { days: 1 }),
          end: new Date()
        },
        area: null,
        vehicle: null
      }
    }
  },

  methods: {
    format
  }
}
</script>